// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pageBox{height:44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.pageBox li{width:42px;height:42px;line-height:42px;background:#fff;border:1px solid #ddd;color:#222;text-align:center;float:left;margin-right:20px}.pageBox .check{background:#0564cd}", ""]);
// Exports
module.exports = exports;
